import { useEffect, useState } from "react";
import Card from 'react-bootstrap/Card';
import { ChevronDoubleLeft, ChevronLeft, ChevronRight, ChevronDoubleRight } from 'react-bootstrap-icons';

const MomentsGallery = ({ moments, selectedMoment, onSelectMoment }) => {
  const [momentIndex, setMomentIndex] = useState(null);
  
  useEffect(() => {
    if (moments && moments.length > 0) {
      if (selectedMoment) {
        const idx = moments.findIndex (moment => moment.id === selectedMoment.id)
        setMomentIndex(idx);
      }
    }
  }, [selectedMoment, moments]);

  const handleMomentNav = (dirAmt) => {
    switch (dirAmt) {
      case 'first':
        if (momentIndex !== 0) {
          onSelectMoment(moments[0])
        }
        break;
      case 'prev': 
        if (momentIndex > 0) {
          const tempIndex = momentIndex - 1
          onSelectMoment(moments[tempIndex])
        }
        break;
      case 'next':
        if (momentIndex < moments.length - 1) {
          const tempIndex = momentIndex + 1
          onSelectMoment(moments[tempIndex])
        }
        break;
      case 'last': 
        if (momentIndex !== moments.length - 1) {
          onSelectMoment(moments[moments.length - 1])
        }
        break;
      default:
        console.log('Unexpected dirAmt:', dirAmt)
    }
  }
  
  return (
    <div className="d-flex flex-column h-100">
      {selectedMoment && 
        <div class="d-flex justify-content-between">
          <ChevronDoubleLeft 
            className='mb-2' 
            color={momentIndex === 0 ? 'gray' : 'blue'} 
            onClick={() => handleMomentNav('first')}
            size={20}
          />
          <ChevronLeft 
            className='mb-2' 
            color={momentIndex === 0 ? 'gray' : 'blue'}  
            onClick={() => handleMomentNav('prev')}
            size={20}
          />
          <h6 className="mb-2">Pictures: {momentIndex + 1} of {moments.length}</h6>
          <ChevronRight 
            className='mb-2' 
            color={momentIndex === moments.length - 1 ? 'gray' : 'blue'}  
            onClick={() => handleMomentNav('next')}
            size={20}
          />
          <ChevronDoubleRight 
            className='mb-2' 
            color={momentIndex === moments.length - 1 ? 'gray' : 'blue'}  
            onClick={() => handleMomentNav('last')}
            size={20}
          />
        </div>
      }
      
      <div className="overflow-auto flex-grow-1">
        {selectedMoment === null ? (
          <Card body>No photos found for this date.</Card>
        ) : (
          <Card 
            id={`moment-${selectedMoment.id}`}
            className="mb-3 cursor-pointer"
          >
            <Card.Img variant="top" src={selectedMoment.pictureUrl} alt={selectedMoment.title || 'Tour photo'} />
            <Card.Body>
              <Card.Text>
                {selectedMoment.description || 'No description'}
                <small className="d-block text-muted">
                  {selectedMoment.photoTime?.toDate().toLocaleTimeString() || ''}
                  {selectedMoment.altitude ? ' (' + Math.round(selectedMoment.altitude) + ' meters)' : ''}
                  {selectedMoment.temperature && selectedMoment.sensorTime &&
                    ' (' + selectedMoment.temperature.toFixed(1) + '°C, ' + 
                    + selectedMoment.humidity.toFixed(1) + '%, ' + 
                    + selectedMoment.pressure.toFixed(1) + ' hPa ' + 
                    '@ ' + selectedMoment.sensorTime.toDate().toLocaleTimeString() + ')' 
                  }
                </small>
              </Card.Text>
            </Card.Body>
          </Card>
        )}
      </div>
    </div>
  );
};
export default MomentsGallery;